import { DOCUMENT, inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

export interface IOpenGraphMetadata {
  title?: string;
  type?: string;
  url?: string;
  image?: string;
  description?: string;
  locale?: string;
  siteName?: string;
}

@Injectable({ providedIn: 'root' })
export class SEOService {
  private title = inject(Title);
  private doc = inject<Document>(DOCUMENT);

  createLinkForCanonicalURL(filterRegex?: RegExp, forceRemovalOfUrl = false) {
    const oldLink = this.doc.querySelector('link[rel="canonical"]');
    if (oldLink) {
      this.doc.head.removeChild(oldLink);
    }

    if (!forceRemovalOfUrl) {
      const link: HTMLLinkElement = this.doc.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.doc.head.appendChild(link);
      let url = this.doc.URL;
      if (filterRegex) {
        url = this.doc.URL.replace(filterRegex, '');
      }
      link.setAttribute('href', url);
    }
  }

  setPageTitle(title: string) {
    this.title.setTitle(title);
  }
}
